import React from 'react';
import ChannelAvatar from './ChannelAvatar';
import './transitions.css';

function TypingBubble({ avatarUrl, label = 'Waiting for a reply' }) {
  return (
    <div
      className="typing-bubble-row chat-anim-rise"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <ChannelAvatar src={avatarUrl} className="typing-bubble-avatar" />
      <div className="typing-bubble">
        <span className="typing-bubble-dot" />
        <span className="typing-bubble-dot" />
        <span className="typing-bubble-dot" />
      </div>
    </div>
  );
}

export default TypingBubble;
